<template>
  <div style="text-align: right">
    <span v-if="!value">-&nbsp;&nbsp;</span>
    <span v-else-if="value === 0">-&nbsp;&nbsp;</span>
    <span v-else>{{ value.toLocaleString('ru-RU') }}</span>
  </div>
</template>

<script>
export default {
  name: 'CbsCellNumber',
  props: {
    value: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style scoped>

</style>
